export const LANGUAGES = [
  { label: "Vietnamese", code: "vn" },
  { label: "English", code: "en" },
];

export const HOTPOT_SOUP_GROUP_CODE = 99;
export const HOTPOT_SOUP_2_CODE = 98;
export const HOTPOT_SOUP_GROUP_4_CODE = 97;
export const IS_ONLY_HOTPOT_4_COMPARTMENT = false;
export const MENU_BF_TYPE = 2;
